import React from "react";
import "../../styles/About.css";
import AboutImg from "../../assets/images/aboutd.png";
import { Link } from "react-router-dom";

function Aboutbanner() {
  return (
    <div>
      <section className="About-banner">
        <div className="About-banner-content">
          <h1>Elevating Brands Through Innovative Web Experiences </h1>
          <p>
            EmpowerWeb specializes in creating modern, responsive, and impactful
            digital experiences tailored to help businesses grow in today’s
            competitive online world. From stunning designs to seamless
            functionality, we build websites that not only look exceptional but
            also deliver meaningful results and lasting impressions.
          </p>
          <Link to="/contact">
            <button className="blogall-btn">Get Free Consultation →</button>
          </Link>
        </div>
        <div className="About-banner-image">
          <img src={AboutImg} alt="Business Growth" />
        </div>
      </section>
      <div>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>About us</span>
        </div>
      </div>
    </div>
  );
}

export default Aboutbanner;
